"use client";

import Link from "next/link";
import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { FeatureItem, type FeatureItemAddress } from "@/components/ui/feature-item";
import { SectionHeader } from "@/components/ui/page-header";
import { containerVariants, itemVariants } from "@/lib/animation-variants";

interface HighlightEvent {
  day: string;
  date: string;
  time: string;
  title: string;
  subtitle?: string;
  description: string;
  address: FeatureItemAddress;
}

const highlightEvents: HighlightEvent[] = [
  {
    day: "DONNERSTAG",
    date: "11.06.",
    time: "18:00 Uhr",
    title: "Begrüßungsabend und Eröffnung",
    description: "Gothenhaus",
    address: {
      line1: "Wilhelm-Busch-Straße 24",
      line2: "30167 Hannover",
    },
  },
  {
    day: "FREITAG",
    date: "12.06.",
    time: "20:00 Uhr c.t.",
    title: "Festkommers",
    subtitle: "Einlass ab 19:30 Uhr · Vorherige Anmeldung erforderlich · Ausverkauft",
    description: "Altes Rathaus",
    address: {
      line1: "Karmarschstraße 42",
      line2: "30159 Hannover",
    },
  },
  {
    day: "SAMSTAG",
    date: "13.06.",
    time: "19:00 Uhr c.t.",
    title: "Festball",
    subtitle: "Einlass ab 18:30 Uhr · Vorherige Anmeldung erforderlich · Ausverkauft",
    description: "Hotel Dormero",
    address: {
      line1: "Hildesheimer Str. 34-38",
      line2: "30169 Hannover",
    },
  },
  {
    day: "SONNTAG",
    date: "14.06.",
    time: "12:00 Uhr",
    title: "Feierlicher Ausklang",
    description: "Gothenhaus",
    address: {
      line1: "Wilhelm-Busch-Straße 24",
      line2: "30167 Hannover",
    },
  },
];

export default function ScheduleHighlights() {
  return (
    <section
      id="agenda-section"
      className="bg-gothia-green px-4 py-20 sm:px-6 lg:px-8">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="mx-auto max-w-7xl">
        <SectionHeader title="PROGRAMM-HIGHLIGHTS" />

        <motion.div
          variants={containerVariants}
          className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {highlightEvents.map((event) => (
            <motion.div key={event.day} variants={itemVariants}>
              <Card
                variant="feature"
                title={event.date}
                titleCaption={event.day}>
                <CardContent>
                  <FeatureItem
                    time={event.time}
                    title={event.title}
                    subtitle={event.subtitle}
                    description={event.description}
                    address={event.address}
                    isLast={true}
                  />
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          variants={itemVariants}
          className="mt-12 text-center">
          <Link
            href="/programm"
            className="inline-flex items-center gap-2 rounded-full bg-gothia-gold/20 px-8 py-4 text-lg font-medium text-gothia-gold transition-all duration-200 hover:bg-gothia-gold/30">
            Vollständiges Programm ansehen
            <span aria-hidden="true">→</span>
          </Link>
        </motion.div>
      </motion.div>
    </section>
  );
}
